import React from "react";
import { getStandaloneComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const AuthBrokerLogoutPage = React.lazy(() => import("@mediaspace-react-components/features/auth-broker-logout"));

export const render = getStandaloneComponentRenderer(AuthBrokerLogoutPage);
